import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProjectCard from "../components/ProjectCard";
import { getProjects } from "../api";

export default function Home() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProjects()
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setProjects(data.slice(0, 3));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        padding: "100px 24px 60px",
        background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0,229,255,0.07) 0%, transparent 70%)",
        position: "relative",
        overflow: "hidden",
      }}>
        <div style={{
          position: "absolute", inset: 0, zIndex: 0,
          backgroundImage: "linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          opacity: 0.3,
        }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div style={{ maxWidth: 720 }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(0,229,255,0.08)", border: "1px solid rgba(0,229,255,0.2)",
              borderRadius: 999, padding: "6px 16px", marginBottom: 32,
            }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent)", display: "inline-block", boxShadow: "0 0 8px var(--accent)" }} />
              <span style={{ fontSize: 13, color: "var(--accent)", fontWeight: 500 }}>Ariyom Tech Solutions</span>
            </div>
            <h1 style={{ fontSize: "clamp(40px, 7vw, 72px)", fontWeight: 800, lineHeight: 1.05, marginBottom: 24 }}>
              Building Apps<br />
              <span style={{ color: "var(--accent)" }}>That Matter</span>
            </h1>
            <p style={{ fontSize: 18, color: "var(--muted)", maxWidth: 540, lineHeight: 1.7, marginBottom: 40 }}>
              From accident detection to e-commerce � we build mobile apps, web platforms, and IoT solutions that solve real-world problems.
            </p>
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
              <Link to="/projects" className="btn btn-primary" style={{ fontSize: 15, padding: "12px 28px", textDecoration: "none" }}>
                View Projects ?
              </Link>
              <Link to="/contact" className="btn btn-outline" style={{ fontSize: 15, padding: "12px 28px", textDecoration: "none" }}>
                Get in Touch
              </Link>
            </div>
            <div style={{ display: "flex", gap: 40, marginTop: 60, flexWrap: "wrap" }}>
              {[
                { num: "5+", label: "Apps Built" },
                { num: "3+", label: "Tech Stacks" },
                { num: "100%", label: "Open Source" },
              ].map((s) => (
                <div key={s.label}>
                  <div style={{ fontSize: 32, fontWeight: 800, fontFamily: "var(--font-display)", color: "var(--accent)" }}>{s.num}</div>
                  <div style={{ color: "var(--muted)", fontSize: 13, marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "80px 24px" }}>
        <div className="container">
          <p className="section-sub" style={{ color: "var(--accent)", fontWeight: 600, fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase" }}>
            Our Work
          </p>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-sub">A selection of things we have built recently.</p>
          {loading ? (
            <div className="spinner" />
          ) : projects.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 0", color: "var(--muted)" }}>
              <p style={{ fontSize: 40, marginBottom: 12 }}>??</p>
              <p>No projects yet. Add some from the Admin Dashboard!</p>
            </div>
          ) : (
            <div className="projects-grid">
              {projects.map((p) => <ProjectCard key={p._id} project={p} />)}
            </div>
          )}
          {projects.length > 0 && (
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <Link to="/projects" className="btn btn-outline" style={{ textDecoration: "none", padding: "12px 28px" }}>
                View All Projects ?
              </Link>
            </div>
          )}
        </div>
      </section>

      <section style={{ padding: "80px 24px" }}>
        <div className="container">
          <div style={{
            background: "linear-gradient(135deg, rgba(0,229,255,0.08), rgba(124,58,237,0.08))",
            border: "1px solid var(--border)",
            borderRadius: 20,
            padding: "60px 40px",
            textAlign: "center",
          }}>
            <h2 style={{ fontSize: "clamp(24px, 4vw, 40px)", fontWeight: 800, marginBottom: 16 }}>
              Have an Idea? Lets Build It.
            </h2>
            <p style={{ color: "var(--muted)", maxWidth: 480, margin: "0 auto 32px", fontSize: 15 }}>
              Whether its a mobile app, web platform, or IoT project � we are ready to bring your vision to life.
            </p>
            <Link to="/contact" className="btn btn-primary" style={{ textDecoration: "none", padding: "13px 32px", fontSize: 15 }}>
              Start a Conversation ?
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
